import request from '@/utils/request'

export function getApprovalSlaInsightOverview () {
  return request({
    url: '/addon/approvalSlaInsight/overview',
    method: 'get'
  })
}
